import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, getApi } from 'services/_api';
import { PATH_CONTABILIZA } from 'services/_path';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { IConsultaNaoProcessadaRequest, Types } from './types';

// ACTIONS
import {
	consultaNaoProcessadaSuccess,
	consultaNaoProcessadaFailure,
} from './actions';

function* consultaNaoProcessada(request: ReducerAction) {
	const { payload }: { payload: IConsultaNaoProcessadaRequest } = request;

	const response: ApiResponse = yield call(
		getApi,
		PATH_CONTABILIZA,
		'contabilizacoes',
		payload,
	);

	if (response.status === 200) {
		yield put(consultaNaoProcessadaSuccess(response.data));
	} else if (response.error) {
		yield put(consultaNaoProcessadaFailure(response.message));
	}
}

export default all([
	takeLatest(Types.CONSULTA_NAO_PROCESSADA, consultaNaoProcessada),
]);
